import * as React from 'react';
import { Avatar, Body1, Link, UIHeading4 } from '@cian/ui-kit';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';

import { IDeveloperCell } from '../../../../../../types/newbuildingsCompare';
import { trackCheckDeveloperInfoEvent } from '../tracking';
import { getDeveloperLink } from './getDeveloperLink';
import * as style from './style.css';

export interface IDeveloperCellDesktopProps {
  cell: IDeveloperCell;
}

export const DeveloperCellDesktop = ({ cell }: IDeveloperCellDesktopProps): React.JSX.Element => {
  const developerLink = getDeveloperLink(cell.data?.id);

  return (
    <div className={style['container']} data-testid="check-developers-page-links">
      <div className={style['image-wrapper']}>
        <Avatar size={56} src={cell.data?.logoUrl} type="builder" hideBorder />
      </div>
      <a
        className={style['developer-name-link']}
        href={developerLink}
        onClick={trackCheckDeveloperInfoEvent}
        target="blank"
      >
        <UIHeading4 color="current_color">{cell.data?.name}</UIHeading4>
      </a>
      <Body1>{cell.data?.workSinceText}</Body1>
      <span className={style['developer-link']}>
        <Link
          color="current_color"
          fontWeight="bold"
          afterIcon={<IconActionChevronRight12 color="current_color" />}
          target="_blank"
          href={developerLink}
          onClick={trackCheckDeveloperInfoEvent}
        >
          О застройщике
        </Link>
      </span>
    </div>
  );
};
